import CameraView from './CameraView';

export default CameraView;
